import {Project} from "../project.entity";

export class DummyProject extends Project {

    protected _uid = `dummy-project`;

}